var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-editor',{ref:"editor",attrs:{"is-edit":true,"definition":_vm.definition,"fetch-by-id":_vm.fetchById,"disabled":_vm.hasNoEditPermission,"save":_vm.saveData,"return-to":_vm.returnTo,"item-type":_vm.entity,"page-loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }